import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RegraPagamentoSubsidio {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root',
})
export class RegraPagamentoSubsidioService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RegraPagamentoSubsidio
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: RegraPagamentoSubsidio[] }>(
        `${this.path}/RegraPagamentoSubsidio`,
        params ? new HttpParams({ fromObject: params }) : this.params
      )
      .pipe(map((response) => response));
  }

  // Get RegraPagamentoSubsidio by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: RegraPagamentoSubsidio }>(
        `${this.path}/RegraPagamentoSubsidio/${id}`
      )
      .pipe(map((response) => response));
  }

  // Create new RegraPagamentoSubsidio
  public store(
    regraPagamentoSubsidio: RegraPagamentoSubsidio
  ): Observable<any> {
    return this.apiService
      .post<{ object: RegraPagamentoSubsidio }>(
        `${this.path}/RegraPagamentoSubsidio`,
        regraPagamentoSubsidio
      )
      .pipe(map((response) => response));
  }

  // Create many RegraPagamentoSubsidio (range)
  public storeRange(regras: RegraPagamentoSubsidio[]): Observable<any> {
    return this.apiService
      .post<{ data: RegraPagamentoSubsidio[] }>(
        `${this.path}/RegraPagamentoSubsidio/range`,
        regras
      )
      .pipe(map((response) => response));
  }

  // Update existing RegraPagamentoSubsidio
  public update(
    regraPagamentoSubsidio: RegraPagamentoSubsidio
  ): Observable<any> {
    return this.apiService
      .put<{ object: RegraPagamentoSubsidio }>(
        `${this.path}/RegraPagamentoSubsidio`,
        regraPagamentoSubsidio
      )
      .pipe(map((response) => response));
  }

  // Delete existing RegraPagamentoSubsidio
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/RegraPagamentoSubsidio/${id}`);
  }
}
